import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/App.js";
import React, { Component } from 'react';
import '../index.css';
import Header from "./navigation/Header";
import { withStyles } from '@material-ui/core/styles';
import Routes from "./Routes";
const styles = theme => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.5em'
    },
    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '1px solid slategrey'
    }
  }
});
class App extends Component {
  constructor(props) {
    super(props);
    // This is required but should never surface
    _defineProperty(this, "homepage", () => {
      return /*#__PURE__*/React.createElement("p", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33,
          columnNumber: 16
        }
      }, "TPIC");
    });
    this.state = {
      partner: null
    };
  }
  render() {
    const classes = this.props.classes;
    return /*#__PURE__*/React.createElement("div", {
      key: this.state.partner,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Header, {
      appRef: this,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.root,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Routes, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 21
      }
    })));
  }
}
export default withStyles(styles)(App);